function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var localList = require('./lang.json').words;

var baseList = require('badwords-list').array;

var Filter =
/*#__PURE__*/
function () {
  /**
   * Filter constructor.
   * @constructor
   * @param {object} options - Filter instance options
   * @param {boolean} options.emptyList - Instantiate filter with no blacklist
   * @param {array} options.list - Instantiate filter with custom list
   * @param {string} options.placeHolder - Character used to replace profane words.
   * @param {string} options.regex - Regular expression used to sanitize words before comparing them to blacklist.
   * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
   */
  function Filter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Filter);

    Object.assign(this, {
      list: options.emptyList && [] || Array.prototype.concat.apply(localList, [baseList, options.list || []]),
      exclude: options.exclude || [],
      placeHolder: options.placeHolder || '*',
      regex: options.regex || /[^a-zA-Z0-9|\$|\@]|\^/g,
      replaceRegex: options.replaceRegex || /\w/g
    });
  }
  /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */


  _createClass(Filter, [{
    key: "isProfane",
    value: function isProfane(string) {
      var _this = this;

      return this.list.filter(function (word) {
        var wordExp = new RegExp("\\b".concat(word.replace(/(\W)/g, '\\$1'), "\\b"), 'gi');
        return !_this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
      }).length > 0 || false;
    }
    /**
     * Replace a word with placeHolder characters;
     * @param {string} string - String to replace.
     */

  }, {
    key: "replaceWord",
    value: function replaceWord(string) {
      return string.replace(this.regex, '').replace(this.replaceRegex, this.placeHolder);
    }
    /**
     * Evaluate a string for profanity and return an edited version.
     * @param {string} string - Sentence to filter.
     */

  }, {
    key: "clean",
    value: function clean(string) {
      var _this2 = this;

      return string.split(/\b/).map(function (word) {
        return _this2.isProfane(word) ? _this2.replaceWord(word) : word;
      }).join('');
    }
    /**
     * Add word(s) to blacklist filter / remove words from whitelist filter
     * @param {...string} word - Word(s) to add to blacklist
     */

  }, {
    key: "addWords",
    value: function addWords() {
      var _this$list,
          _this3 = this;

      var words = Array.from(arguments);

      (_this$list = this.list).push.apply(_this$list, _toConsumableArray(words));

      words.map(function (word) {
        return word.toLowerCase();
      }).forEach(function (word) {
        if (_this3.exclude.includes(word)) {
          _this3.exclude.splice(_this3.exclude.indexOf(word), 1);
        }
      });
    }
    /**
     * Add words to whitelist filter
     * @param {...string} word - Word(s) to add to whitelist.
     */

  }, {
    key: "removeWords",
    value: function removeWords() {
      var _this$exclude;

      (_this$exclude = this.exclude).push.apply(_this$exclude, _toConsumableArray(Array.from(arguments).map(function (word) {
        return word.toLowerCase();
      })));
    }
  }]);

  return Filter;
}();

module.exports = Filter;